import React from 'react';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRoomResource from 'resources/SMRoomResource';

class SMFormRoomSelectBox extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      ownerId: this.props.ownerId,
      selectedValue: this.props.selectedValue,
      spaceId: this.props.spaceId,
      roomId: this.props.roomId,
      rooms: [],
    };
  }
  
  componentDidMount(){
    if (this.state.spaceId) {
      this.requestResource(this.state.spaceId);
    }
  }
  
  componentWillReceiveProps(nextProps) {
    let state = Object.assign({}, this.state);
    if (this.state.spaceId != nextProps.spaceId) {
      state.spaceId = nextProps.spaceId;
      if (state.spaceId) {
        this.requestResource(state.spaceId);
      } else {
        state.rooms = [];
      }
    }
    if (this.state.roomId != nextProps.roomId) {
      state.roomId = nextProps.roomId;
    }
    this.setState(state);
  }

  requestResource(spaceId) {
    if (this.props.isUser) {
      SMRoomResource.getRooms({
        space_id: spaceId,
        per_page: 250
      }, (rooms, error)=> {
        if (!error) {
          this.setState({rooms: rooms});
        }
      });
    } else {
      SMOwnerResource.getRooms(this.state.ownerId, {
        space_id: spaceId,
        per_page: 250
      }, (rooms, error)=> {
        if (!error) {
          this.setState({rooms: rooms});
        }
      });
    }
  }
  
  didChangeValue(e) {
    if(this.props.delegate && typeof this.props.delegate.roomSelectBoxDidChangeValue === 'function'){
      this.props.delegate.roomSelectBoxDidChangeValue(e.currentTarget.value);
    }
  }
  
  renderOptions(){
    let rows = [];
    for (let i = 0; i < this.state.rooms.length; i++) {
      const room = this.state.rooms[i];
      rows.push(
        <option key={room.id} value={room.uid}>{SMFormatHelper.roomName(room)}</option>
      );
    }
    return rows;
  }

  render() {
    return (
      <select name="room_id" value={this.state.roomId} className={this.props.options.className} onChange={this.didChangeValue.bind(this)} disabled={this.props.options.disabled}>
        <option value="">{I18n.t("dashboard.label_000103")}</option>
        {this.renderOptions()}
      </select>
    );
  }
}

SMFormRoomSelectBox.defaultProps = {
  options: {
    className: "",
    disabled: false
  },
  isUser: false
};

export default SMFormRoomSelectBox;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormRoomSelectBox.jsx